export const SIDEBAR_W = 280;
export const SIDEBAR_COLLAPSED_W = 72;
